import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: false,
  loggedInUser: null,
  accessToken: null,
  logoutByExpertAction: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    updateLoginStatus: (state, action) => {
      state.isLoggedIn = action.payload;
    },
    updateLoggedInUser: (state, action) => {
      state.loggedInUser = action.payload;
    },
    updateAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    resetState: (state, action) => {
      state = undefined;
    },
    logoutByExpert: (state, action) => {
      state.logoutByExpertAction = action.payload;
    },
  },
});

export const {
  updateLoginStatus,
  updateLoggedInUser,
  updateAccessToken,
  resetState,
  logoutByExpert,
} = authSlice.actions;
export default authSlice.reducer;
